const transcriptElement = document.getElementById("transcript")
if (!transcriptElement) {
  throw new Error("No transcript element found")
}

const lineSplitterElement = document.getElementById("line-splitter")
if (!lineSplitterElement) {
  throw new Error("No lineSplitter element found")
}

const setTranscript = (text: string) => {
  transcriptElement.textContent = text;
};

(async () => {
  setTranscript("Checking webkitSpeechRecognition...");
  // Heavily inspired by https://www.google.com/intl/en/chrome/demos/speech.html
  if (window.webkitSpeechRecognition && !window.SpeechRecognition) {
    window.SpeechRecognition = window.webkitSpeechRecognition;
  }

  setTranscript("Checking SpeechRecognition...");
  if (!window.SpeechRecognition) {
    setTranscript("Web Speech API is not available.");
    throw new Error("Web Speech API is not available.");
  }

  setTranscript("init SpeechRecognition...");
  const searchParams = new URLSearchParams(window.location.search);
  const visibleLines = searchParams.get("visibleLines") || 3;
  const resetOnPauseInSeconds =
    Number(searchParams.get("resetOnPauseInSeconds")) || 2;

  // 'en-US' or 'fr-FR'

  const recognition = new SpeechRecognition();

  recognition.lang = searchParams.get("lang") || "fr-FR"; // 'en-US', 'fr-FR', etc
  recognition.continuous = true;
  recognition.interimResults = true;
  recognition.processLocally = !!searchParams.get("processLocally");

  recognition.onend = (e) => console.warn("onend", e);
  recognition.onerror = (e) => console.error("error", e.error, e);
  recognition.onstart = (e) => {
    console.warn("onstart", e);
    transcriptElement!.textContent = "";
  };

  let clearTimeoutId: number; // No refresh to empty page as long as there is no word spoken

  // https://www.bennadel.com/blog/4310-detecting-rendered-line-breaks-in-a-text-node-in-javascript.htm
  const splitTextInLines = (text: string) => {
    const lineSplitterElement = document.getElementById("line-splitter")
    if (!lineSplitterElement) {
      throw new Error("No lineSplitter element found")
    }
    lineSplitterElement.textContent = text;

    const textNode = lineSplitterElement.firstChild;
    if (!textNode) {
      throw new Error("No textNode in lineSplitter element found")
    }

    const lines = [];
    const range = document.createRange();
    let currentLineCharacters: string[] = [];

    for (var i = 0; i < text.length; i++) {
      range.setStart(textNode, 0);
      range.setEnd(textNode, i + 1);

      const lineIndex = range.getClientRects().length - 1;

      if (!lines[lineIndex]) {
        currentLineCharacters = [];
        lines.push(currentLineCharacters);
      }

      currentLineCharacters.push(text.charAt(i));
    }

    return lines.map((line) => line.join(""));
  };

  recognition.onresult = function (event) {
    let transcript = "";

    if (!event.results) {
      return;
    }

    for (var i = event.resultIndex; i < event.results.length; ++i) {
      transcript += event.results[i]?.[0]?.transcript ?? "";
    }

    const transcriptLines = splitTextInLines(transcript);

    setTranscript(transcriptLines
      .slice(-visibleLines)
      .join(""))

    if (resetOnPauseInSeconds <= 0) {
      return;
    }

    if (clearTimeoutId) {
      clearTimeout(clearTimeoutId);
    }

    clearTimeoutId = setTimeout(
      () => window.location.reload(),
      resetOnPauseInSeconds * 1000,
    );
  };

  setTranscript("Starting recognition...");
  recognition.start();

  // // Default SpeechRecognition#start does not let the user chose the mic, this way it does.

  // setTranscript('Requesting microphone access...')
  // const stream = await navigator.mediaDevices.getUserMedia({
  //     audio: true,
  //     video: false,
  // })

  // setTranscript('Starting recognition...')
  // recognition.start(stream)

  // // End of the road: OBS use CEF, Chromium Embedded Framework, which does not support the Web Speech API "as-a-service" since it is using Google services.
  // // Next step, try using processLocally mode, that will also make it work with Firefox if I understood correctly
})()
